import { Component, OnInit, Input, Output, EventEmitter,ViewChild, HostListener, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MedioPagosService } from "../../servicios/medio-pagos.service";
import { CobrosService } from "../../servicios/cobros.service";
import { CatBancosService } from "../../servicios/cat-bancos.service";
import { CatMedioPagosService } from "../../servicios/cat-medio-pagos.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MedioPagos } from '../../entidades/entidades';
import { Cobros } from "../../entidades/entidades";
import { CatBancos } from "../../entidades/entidades";
import { CatMedioPagos } from "../../entidades/entidades";

declare var $: any;

@Component({
  selector: "app-medio-pagos",
  templateUrl: "./medio-pagos.component.html",
  styleUrls: ["./medio-pagos.component.css"]
})

export class MedioPagosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
cobros: Cobros[] = [];
catBancos: CatBancos[] = [];
catMedioPagos: CatMedioPagos[] = [];
  medioPagosForm: FormGroup;
  flagmostrar:boolean =false;
  flagrequiereFecha:boolean =false;
   
   MedioPago={
    monto:0,
    medio_pago:null,
    banco:null,
    referencia:null,
    autorizacion:null,
    fechadeposito:null
  };
  MedioPagosTable:any[] = [];
  MedioPagoTable:MedioPagos[]=[];
  Medios:MedioPagos[]=[];
  public tableWidget: any;

  totalRecibe: number = 0;
  totalResp = 0;
  medioSeleccionado: number;
  chequeoTarjeta: string = 'No. Tarjeta';

  public esAbono : boolean = false;
 
  @Input("medioPagos") medioPagos: MedioPagos;
  @Input("conRedondeo") conRedondeo: boolean;
  @Input("esCajaAgua") esCajaAgua: boolean = true;
  @Output("medioPagosOutput") medioPagosOutput: EventEmitter<MedioPagos>;
  @ViewChild('montoInput') montoInput!: ElementRef;
  @ViewChild('addButton', { static: false }) addButton!: ElementRef;
  @ViewChild('medioPagosSelect') medioPagosSelect!: ElementRef;

  // Escuchar el evento de teclado a nivel del documento
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
  
    if (event.key === '+') {
      if (this.montoInput) {
        this.montoInput.nativeElement.focus();
      }
      event.preventDefault();
      this.recarga();
    }
    if (event.key === '-') { // Escuchar la tecla "-"
      event.preventDefault();
      // Establece el foco en el select y despliega sus opciones
      const selectElement = this.medioPagosSelect.nativeElement;
      selectElement.focus();
      selectElement.click(); // Esto simula un clic para mostrar las opciones
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private medioPagosService: MedioPagosService,
    private cobrosService: CobrosService,
    private catBancosService: CatBancosService,
    private catMedioPagosService: CatMedioPagosService,
    private route: ActivatedRoute
  ) {
    this.medioPagosOutput = new EventEmitter()
  }

  ngOnInit() {
//this.getAllCobros();
this.getAllCatBancos();
this.getAllCatMedioPagos();
    this.medioPagosForm = this.formBuilder.group({
      id : [undefined  ],
      idCobro : [undefined  ],
      idBanco : [undefined  ],
      idMedioPago : [undefined  ],
      monto : [undefined ],
      referencia : [undefined ,[Validators.maxLength(20)] ],
      fechaDeposito : [undefined  ],
      autorizacionTarjeta : [undefined ,[Validators.maxLength(16)] ],
      esAdelantado:[undefined],
    });
    //if (this.medioPagos) this.medioPagosForm.patchValue(this.medioPagos);
    this.MedioPagoTable  = [];
    this.MedioPagosTable = [];
    console.log('Inicia MediosPago');

    if(this.medioPagos)
    {
      console.log('Trae medio pago: ', this.medioPagos);
    }
    this.medioPagosForm.patchValue({
      idMedioPago: 1
    });
    this.flagmostrar = true;
    this.flagrequiereFecha = true;
  }
  ngOnChanges() {
    if(!this.medioPagos)
    {
      return;
    }
    if(this.medioPagos.idMedioPago)
    {
      console.log('Trae medio pago ngOnChanges: ', this.medioPagos.idMedioPago);
      this.asignaMedio(this.medioPagos);
    }else if(!this.medioPagos.idMedioPago)
    {
      this.totalRecibe = this.medioPagos.monto;
      this.totalResp   = this.medioPagos.monto;
      console.log('Trae Total: ', this.medioPagos);
    }
  }


  async getAllMedioPagos() {
    try {
      const datoRetorno = await this.medioPagosService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllMedioPagos");
    }
  }

async getAllCobros() {
    try {
      const datoRetorno = await this.cobrosService.getAll().toPromise();
      this.cobros = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCobros");
    }
  }

async getAllCatBancos() {
    try {
      const datoRetorno = await this.catBancosService.getAll().toPromise();
      this.catBancos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatBancos");
    }
  }

async getAllCatMedioPagos() {
    try {
      const datoRetorno = await this.catMedioPagosService.getAll().toPromise();
      this.catMedioPagos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatMedioPagos");
    }
  }

  async handleChange(datos)
  {
    console.log('datos: ', datos);
    if(datos.checked == true)
    {
      this.esAbono = true;
      this.medioPagos.monto = 0;
      this.medioPagos.esAbono = true;
      this.medioPagosOutput.emit(this.medioPagos);
      this.MedioPagosTable = [];
      this.MedioPagoTable = [];
      this.limpia();
    }else{
      this.esAbono = false;
      this.medioPagos.monto = 0;
      this.medioPagos.esAbono = false;
      this.medioPagosOutput.emit(this.medioPagos);
      this.MedioPagosTable = [];
      this.MedioPagoTable = [];
      this.limpia();
    }
  }

  async selectOPtion()
  {
    this.medioPagos  = this.medioPagosForm.value;
    console.log('id Medio',this.medioPagos.idMedioPago)
    let catMedioPago = new CatMedioPagos();
    catMedioPago = this.catMedioPagos.find(x=> x.id ===this.medioPagos.idMedioPago);

    this.medioSeleccionado = catMedioPago.id;
    console.log("se imprime Medio: ",this.medioSeleccionado);

    if(this.medioSeleccionado == 2){
        this.chequeoTarjeta = 'No. Cheque';
    }else{
      this.chequeoTarjeta = 'No. Tarjeta';
    }

    console.log('cat',catMedioPago)
    if(catMedioPago.requiereBanco){
      this.flagmostrar=false;
      console.log('bandera',this.flagmostrar)
    }else
      this.flagmostrar=true;
     if(catMedioPago.requiereFechaDeposito)
     {
        this.flagrequiereFecha=false;
     }
     else 
       this.flagrequiereFecha=true;
  }
 
  async recarga() 
  {
    debugger;
    try 
    {
     
      this.MedioPago={
        monto: 0,
        medio_pago: null,
        banco: null,
        referencia: null,
        autorizacion: null,
        fechadeposito: null
      };

      if (this.medioPagosForm.invalid) throw new Error("No paso las validaciones.");

      this.medioPagos  = this.medioPagosForm.value;  
      
      // VALIDACION PEDIR UN BANCO 
      // if(!this.medioPagos.idBanco && (this.medioPagos.idMedioPago == 2 || this.medioPagos.idMedioPago == 4 
      //   || this.medioPagos.idMedioPago == 3 || this.medioPagos.idMedioPago == 5))
      // {
      //   this.muestraMensaje.error("Necesitas seleccionar algún banco.", "top", "center");
      //   return;
      // }

      if(this.medioPagos.monto <= 0)
      {
        this.muestraMensaje.error("No puedes ingresar un monto igual o menor a 0.", "top", "center");
        return;
      }
      // if(this.totalRecibe <= 0 && !this.esAbono)
      // {
      //   this.totalRecibe = 0;
      //   this.muestraMensaje.error("Ya no resta nada por pagar.", "top", "center");
      //   return;
      // }
      // let longitudTabla = 0;
      // this.MedioPagosTable.forEach(element => {longitudTabla = longitudTabla + 1;});

      let longitudTabla = this.MedioPagosTable?.length;
      //ASIGNA EL MEDIO DE PAGO A EMITIR A CAJAS
      this.MedioPago.monto = this.medioPagos.monto;
      
      //SI LA VARIABLE esAbono ES TRUE NO VALIDA EL MONTO TOTAL, PERMITE INGRESAR INFINIDAD DE VALORES
      if(this.esAbono == true)
      {
        this.medioPagos.esAbono = true;
        //VALIDA SI LA TABLA CONTIENE ELEMENTOS 
        if(longitudTabla > 0)
        {
          //REALIZA UN CICLO REVISANDO SI YA EXISTEN MEDIOS DE PAGO IGUALES Y EN ESE CASO SUMAR MONTOS
          for(var i = 0; i < this.MedioPagoTable.length; i++)
          {
            if(this.MedioPagoTable[i].idMedioPago == this.medioPagos.idMedioPago
              && this.MedioPagoTable[i].referencia == this.medioPagos.referencia
              && this.MedioPagoTable[i].idBanco == this.medioPagos.idBanco
              && this.MedioPagoTable[i].autorizacionTarjeta == this.medioPagos.autorizacionTarjeta)
            {
              let medioP = new MedioPagos();
              medioP.monto = this.MedioPagosTable[i].monto + this.medioPagos.monto;
              this.MedioPagosTable[i].monto = medioP.monto;
              this.MedioPagoTable[i].monto = medioP.monto;
              this.medioPagosOutput.emit(this.medioPagos);
              await this.limpia();
              return;
            }
            else
            {
              // if(this.medioPagos.monto >= this.totalRecibe)
              // {
              //   this.MedioPago.monto = this.totalRecibe;
              // }else{
              this.MedioPago.monto = this.medioPagos.monto;
            }
          }
        }else
        {
          //SI EL MONTO INGRESADO ES MAYOR AL TOTAL SE ASIGNA EL MONTO TOTAL
          // if(this.medioPagos.monto >= this.totalRecibe)
          // {
          //   this.MedioPago.monto = this.totalRecibe;
          // }else{
            this.MedioPago.monto = this.medioPagos.monto;
          // }
        }
          this.medioPagos.esAbono = true;
      }else{
        this.medioPagos.esAbono = false;
        //VALIDA SI EL MEDIO DE PAGO ES MAYOR O MENOR AL TOTAL DE LA CAJA
        if(this.medioPagos.monto >= this.totalRecibe)
        {
          //VALIDA SI LA TABLA CONTIENE ELEMENTOS CUANDO EL MONTO INGRESADO ES MAYOR AL TOTAL EN CAJA
          if(longitudTabla > 0)
          {
            //REALIZA UN CICLO REVISANDO SI YA EXISTEN MEDIOS DE PAGO IGUALES Y EN ESE CASO SUMAR MONTOS
            for(var i = 0; i < this.MedioPagoTable.length; i++)
            {
              //VALIDA SI EXISTE UN METODO DE PAGO DE IGUAL EN EL GRID
              if(this.MedioPagoTable[i].idMedioPago == this.medioPagos.idMedioPago
                && this.MedioPagoTable[i].referencia == this.medioPagos.referencia
                && this.MedioPagoTable[i].idBanco == this.medioPagos.idBanco
                && this.MedioPagoTable[i].autorizacionTarjeta == this.medioPagos.autorizacionTarjeta)
                {
                  let medioP = new MedioPagos();
                  //SI EL MEDIO DE PAGO ES MAYOR AL TOTAL DE CAJA EL MONTO INGRESADO SERÁ EL TOTAL DE LA CAJA
                  if( this.medioPagos.monto >= this.totalRecibe)
                  {
                    
                    medioP.monto = this.MedioPagosTable[i].monto + (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe); 
                  }else{
                    
                    medioP.monto = this.MedioPagosTable[i].monto + this.medioPagos.monto;
                  }
                  // SE ASIGNA EL VALOR AL MONTO DEL RENGLON Y SE EMITE A LA CAJA
                  this.MedioPagosTable[i].monto = medioP.monto;
                  this.MedioPagoTable[i].monto = medioP.monto;
      
                  // EL MONTO INGRESADO SE RESTA AL TOTAL DE LA CAJA
                  this.totalRecibe = this.totalRecibe - this.medioPagos.monto;
                  this.medioPagosOutput.emit(this.medioPagos);
                  await this.limpia();
                  return;
                }else{
                  console.log('Son diferentes 1');
                  //SI EL METODO INGRESADO NO EXISTE EN LA TABLA SOLO VALIDA QUE NO SE EXCEDA EL TOTAL DE CAJA
                  if(this.medioPagos.monto >= this.totalRecibe)
                  {

                    this.MedioPago.monto = + (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe);
                  }else{

                    this.MedioPago.monto = this.medioPagos.monto;
                   }
                }
            }
          }else{
            //SI EL MONTO INGRESADO ES MAYOR AL TOTAL SE ASIGNA EL MONTO TOTAL
            if(this.medioPagos.monto >= this.totalRecibe)
            {
              this.MedioPago.monto =  (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe); 
            }else{
              this.MedioPago.monto = this.medioPagos.monto;
             }
          }
        }else
        {
           //VALIDA SI EL GRID CONTIENE ELEMENTOS CUANDO EL MONTO INGRESADO ES MENOR AL TOTAL
          if(longitudTabla > 0)
          {
            //REALIZA UN CICLO REVISANDO SI YA EXISTEN MEDIOS DE PAGO SIGUALES Y EN ESE CASO SUMAR MONTOS
            for(var i = 0; i < this.MedioPagoTable.length; i++)
            {
              //VALIDA SI EXISTE UN METODO DE PAGO DE IGUAL EN EL GRID
              if(this.MedioPagoTable[i].idMedioPago == this.medioPagos.idMedioPago
                && this.MedioPagoTable[i].referencia == this.medioPagos.referencia
                && this.MedioPagoTable[i].idBanco == this.medioPagos.idBanco
                && this.MedioPagoTable[i].autorizacionTarjeta == this.medioPagos.autorizacionTarjeta)
                {
                  let medioP = new MedioPagos();
                  //SI EL MEDIO DE PAGO ES MAYOR AL TOTAL DE CAJA EL MONTO INGRESADO SERÁ EL TOTAL DE LA CAJA
                  if( this.medioPagos.monto >= this.totalRecibe)
                  {
                    
                    medioP.monto = this.MedioPagosTable[i].monto + (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe); 
                  }else{
                    
                    medioP.monto = this.MedioPagosTable[i].monto + this.medioPagos.monto;
                   }
                  this.MedioPagosTable[i].monto = medioP.monto;
                  this.MedioPagoTable[i].monto = medioP.monto;
                  this.totalRecibe = this.totalRecibe - this.medioPagos.monto;
                  this.medioPagosOutput.emit(this.medioPagos);
                  await this.limpia();
                  return;
                }else{
                  //SI EL METODO INGRESADO NO EXISTE EN LA TABLA SOLO VALIDA QUE NO SE EXCEDA EL TOTAL DE CAJA
                  if(this.medioPagos.monto >= this.totalRecibe)
                  {
                    console.log('Son diferentes 2.1');
                    this.MedioPago.monto =  (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe); 
                  }else{
                    console.log('Son diferentes 2.1');
                    this.MedioPago.monto = this.medioPagos.monto;
                  }
                }
            }
          }else{
            //SI EL MONTO INGRESADO ES MAYOR AL TOTAL SE ASIGNA EL MONTO TOTAL
            if(this.medioPagos.monto >= this.totalRecibe)
            {                              
              this.MedioPago.monto = (this.conRedondeo? Math.ceil( this.totalRecibe): this.totalRecibe); 
            }else{
              this.MedioPago.monto = this.medioPagos.monto;
            }
          }
          
        }
        this.totalRecibe = this.totalRecibe - this.MedioPago.monto;
      }

      this.MedioPago.referencia = this.medioPagos.referencia;
      this.MedioPago.autorizacion = this.medioPagos.autorizacionTarjeta;
      this.MedioPago.fechadeposito = this.medioPagos.fechaDeposito;
      let catMedioPago = this.catMedioPagos.find(x=> x.id ===this.medioPagos.idMedioPago);

      this.MedioPago.medio_pago = catMedioPago.descripcion;

      if(this.medioPagos.idBanco > 0)
      {
        let catBanco=this.catBancos.find(x=> x.id===this.medioPagos.idBanco);
        this.MedioPago.banco=catBanco.descripcion;
      }
      await this.MedioPagosTable.push(this.MedioPago);
      await this.MedioPagoTable.push(this.medioPagos);
      
      console.log("se imprime 1",this.MedioPagosTable);
      console.log("se imprime 2",this.MedioPagoTable);

      this.medioPagosOutput.emit(this.medioPagos);
      console.log('Emite medio: ', this.medioPagos);
     
      await this.limpia();
     
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por recarga");
    }
  }
  
  async selectRow(index: number, row: any) 
  {
    console.log('Renglon seleccionado:', index,row);
    if(this.totalRecibe < 0)
    {
      this.totalRecibe = 0;
    }

    this.medioPagos.monto = row.monto + (row.monto*-2);
    this.totalRecibe = this.totalRecibe + row.monto;
    
    this.MedioPagosTable.splice(index,1);
    this.MedioPagoTable.splice(index,1);
    console.log(this.MedioPagosTable);

    if(this.MedioPagoTable.length == 0)
    {
      this.totalRecibe = this.totalResp;
    }
    console.log("Total Actual ",this.totalRecibe, "  ->", this.totalResp);
    this.medioPagosOutput.emit(this.medioPagos);
    await this.limpia();
  }

  async asignaMedio(medioP: MedioPagos)
  {
    console.log("Entra a asignaMedios.");
    this.MedioPago={
      monto: null,
      medio_pago: null,
      banco: null,
      referencia: null,
      autorizacion: null,
      fechadeposito: null
    };
    await console.log("aqui ",this.MedioPagosTable);
    if (this.medioPagosForm.invalid) {
      throw new Error("No paso las validaciones.");
    }
    await this.medioPagosForm.patchValue({
      monto: medioP.monto,
      idMedioPago : 1
    });
    
    this.medioPagos  = this.medioPagosForm.value;  
    
    this.MedioPago.monto = this.medioPagos.monto;
    this.MedioPago.medio_pago = 'EFECTIVO';

    await this.MedioPagosTable.push(this.MedioPago);
    await this.MedioPagoTable.push(this.medioPagos);
    
    console.log("se imprime ",this.MedioPagoTable);
    await this.medioPagosOutput.emit(this.medioPagos);
    
    await console.log('Emite medio: ',medioP);
   
    //await this.muestraMensaje.notification("Proceso Concluido Medio.", "top", "center");
    
    await this.seleccionAutomatica();
    await this.limpia();
  }

  async seleccionAutomatica(){
    this.medioPagos  = this.medioPagosForm.value;
    await console.log('id Medio',this.medioPagos.idMedioPago)
    let catMedioPago = new CatMedioPagos();
    catMedioPago = this.catMedioPagos.find(x=> x.id ===this.medioPagos.idMedioPago);
    await console.log('cat',catMedioPago)
    
    this.flagmostrar = true;
    this.flagrequiereFecha = true;
  }

  async limpia(){
    try{
      
    
     if(this.MedioPago.autorizacion!=null || this.medioPagosForm.value.autorizacionTarjeta != null){
      (document.getElementById('medio_pagos_autorizacionTarjeta')  as HTMLInputElement).value="";
      console.log("aqui");
      this.medioPagosForm.patchValue({
        autorizacionTarjeta: null
      });
     }
        
     if(this.MedioPago.medio_pago!=null || this.medioPagosForm.value.idMedioPago != null){
      (document.getElementById('medio_pagos_idMedioPago')  as HTMLInputElement).value="" ;
      console.log("aqui 1");
      this.medioPagosForm.patchValue({
        idMedioPago: 1
      });
     }
        
      if(this.MedioPago.monto!=null || this.medioPagosForm.value.monto != null){
        (document.getElementById('medio_pagos_monto')  as HTMLInputElement).value= "";
        console.log("aqui 2");
        this.medioPagosForm.patchValue({
          monto: null
        });
      }
        
      if(this.MedioPago.banco!=null || this.medioPagosForm.value.idBanco != null){
        (document.getElementById('medio_pagos_idBanco')  as HTMLInputElement).value= "";
        console.log("aqui 3");
        this.medioPagosForm.patchValue({
          idBanco: null
        });
      }
      
      if(this.MedioPago.referencia!=null || this.medioPagosForm.value.referencia != null){
        console.log("entre");
        (document.getElementById('medio_pagos_referencia')  as HTMLInputElement).value= "";
        console.log("aqui 4");
        this.medioPagosForm.patchValue({
          referencia: null
        });
      }
        
      if(this.MedioPago.fechadeposito!=null || this.medioPagosForm.value.fechaDeposito != null){
        (document.getElementById('medio_pagos_fechaDeposito')  as HTMLInputElement).value= "";
        console.log("aqui 5")
        this.medioPagosForm.patchValue({
          fechaDeposito: null
        });
      }
      this.MedioPago={
        monto: null,
        medio_pago: null,
        banco: null,
        referencia: null,
        autorizacion: null,
        fechadeposito: null
      };
      console.log("limpia objeto",this.MedioPago);  

      this.selectOPtion();
    }catch(e){
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }
  async limpiaGrid() {
    try
    {
       this.MedioPagosTable.splice(0);
       this.MedioPagoTable = [];
    } 
    catch (e)
    {
     console.log(e.message);
     this.muestraMensaje.error(e.message, 'top', 'center');
    }finally {
     console.log('Paso por limpia');
   }
   }

  
}